// extracted by mini-css-extract-plugin
export default {"form":"dj5AuZ0Ri8R_xHF1aIlf","applePayButton":"BheVOa2RuoP4u7snLEup","divider":"fGWWSbU45AiYnyj1dy_Y"};